import { render } from "./BildAuswahl.vue?vue&type=template&id=6d2cb77d&scoped=true"
import script from "./BildAuswahl.vue?vue&type=script&lang=js"
export * from "./BildAuswahl.vue?vue&type=script&lang=js"

import "./BildAuswahl.vue?vue&type=style&index=0&id=6d2cb77d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2cb77d"]])

export default __exports__